import { format } from "lib/globalize-util.js";

export const fetchTemplateEndpoint = (id: string) => `/api/v3.0/working-order/export-formats/${id}`;
export const fetchTemplatesEndpoint = () => "/api/v3.0/working-order/export-formats";

export const createTemplateQuery = () => {
    return {
        body: {
            name: format("Untitled Template"),
        },
        options: {
            method: "POST",
        },
        url: "/api/v3.0/working-order/export-formats",
    };
};

export const deleteTemplateQuery = (id: string) => {
    return {
        options: {
            method: "DELETE",
        },
        url: `/api/v3.0/working-order/export-formats/${id}`,
    };
};

export const updateTemplateQuery = (id: string, changes: any) => {
    return {
        body: changes,
        options: {
            method: "PATCH",
        },
        url: `/api/v3.0/working-order/export-formats/${id}`,
    };
};

export const updateRowOrderQuery = (id: string, changes: any) => {
    return {
        body: changes,
        options: {
            method: "PUT",
        },
        url: `/api/v3.0/working-order/export-formats/${id}/fields/sort`,
    };
};

export const addRowQuery = (id: string, options: any) => {
    return {
        body: options,
        options: {
            method: "POST",
        },
        url: `/api/v3.0/working-order/export-formats/${id}/field`,
    };
};

export const deleteRowQuery = (id: string, fieldId: string) => {
    return {
        options: {
            method: "DELETE",
        },
        url: `/api/v3.0/working-order/export-formats/${id}/field/${fieldId}`,
    };
};

export const updateRowQuery = (id: string, fieldId: string, changes: any) => {
    return {
        body: changes,
        options: {
            method: "PATCH",
        },
        url: `/api/v3.0/working-order/export-formats/${id}/field/${fieldId}`,
    };
};

// todo: support for preview
export const generatePreviewQuery = (id: string) => {
    return {
        body: {
            order_export_format_id: id,
            order_object: {
                line_items: [],
                retailer: {},
            },
        },
        options: {
            method: "POST",
        },
        url: "/api/v3.0/working-order/export",
    };
};

export const fetchPreviewQuery = (id: string) => {
    return {
        options: {
            method: "GET",
        },
        url: `/api/v3.0/working-order/export/${id}`,
    };
};
